// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { API_TRANSPORTISTAS } from "../views/MainLayout/components/shared/services/transportistas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialTransportistas = []

export const transportistasFullfilledReducer = (state = initialTransportistas, action) => {
    switch(action.type){
        case "transportistas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchTransportistas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_TRANSPORTISTAS.getTransportistas()
        const data = await response.data;
        dispatch({ type: 'transportistas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}